

  <div *ngIf="historyItems && historyItems.length > 0" class="history-list-container">
    <div class="history-item"
         *ngFor="let item of historyItems"
         (click)="selectLegalEntity(item)">
      <div class="le-item">
        <div class="le-name">
          <i class="dx-icon-user dx-avatar"></i>
          <span>{{ item.legalEntityName }}</span>
        </div>
        <div class="le-secondary">{{ item.legalEntityType }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="!historyItems || historyItems.length === 0" class="empty-history">
    <p>No recent legal entities found.</p>
  </div>

